import { Pipe, PipeTransform } from '@angular/core';
import { StyleOfCauseModel } from '../models/style-of-cause.model';

const toFirstTwoElems = (prev: string, curr: string, i: number) =>
  i === 0 ? curr : i === 1 ? `${prev}; ${curr}` : i === 2 ? `${prev}...` : prev;

@Pipe({
  name: 'reduceStyleOfCause',
  pure: true,
})
export class ReduceStyleOfCausePipe implements PipeTransform {
  transform(value: StyleOfCauseModel): string {
    let plaintiffs = '';
    let defendants = '';
    if (value) {
      plaintiffs = value.plaintiffs.reduce(toFirstTwoElems, '');
      defendants = value.defendants.reduce(toFirstTwoElems, '');
    }
    if (!plaintiffs || !defendants) return '';
    if (
      plaintiffs.toLowerCase().includes('(confidential)') ||
      defendants.toLowerCase().includes('(confidential)')
    ) {
      return 'Confidential';
    }
    // extra spaces added on purpose
    return `${plaintiffs} &nbsp;&nbsp; vs. &nbsp;&nbsp; ${defendants}`;
  }
}
